export default "__VITE_ASSET__HFQo5bxP__"